import { createSelector } from 'reselect'

import { ApplicationState } from '../../interfaces'
import { MarxentState } from './reducer'

const getRoot = ({ marxent }: ApplicationState): MarxentState => marxent

export const getMxtJourney = createSelector(getRoot, marxent => marxent.journey)
